<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>

    <div class="row clearfix">

      <div class="col-lg-3 col-md-6 col-sm-6" *ngIf="checkPrivilege(['super_agent'])">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Number of Agents</h6>
              <span>{{ dashboard?.total_agents || 0 }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Number of Operators</h6>
              <span>{{ dashboard?.total_riders || 0 }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
     <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Wallet Balance</h6>
              <span>{{ dashboard?.total_wallet_sum || 0 | currency: '&#8358;'  }}</span>
            </div>
            <!-- &lt;!&ndash;<small class="text-muted">19% compared to last week</small>&ndash;&gt; -->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Total Enrolment Payment</h6>
              <span>{{ dashboard?.total_enrolment || 0 | currency: '&#8358;'  }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Total Daily Collection</h6>
              <span>{{ dashboard?.total_payment || 0 | currency: '&#8358;'  }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Number of Super Agents</h6>
              <span>{{ dashboard?.total_super_agents || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Operator Paid Payment</h6>
              <span>{{ dashboard?.rider_payment || 0 | currency: '&#8358;' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix">
    </div>
  </div>
</div>
